// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","home_contact-icon":"Home_home_contact-icon__mqbPt"};